var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchLeft = function SvgSearchLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8761 16.484L13.6083 12.2162C13.5275 12.1353 13.422 12.0932 13.3095 12.0932H12.8455C13.9528 10.81 14.6243 9.14018 14.6243 7.31214C14.6243 3.27289 11.3514 0 7.31214 0C3.27289 0 0 3.27289 0 7.31214C0 11.3514 3.27289 14.6243 7.31214 14.6243C9.14018 14.6243 10.81 13.9528 12.0932 12.8455V13.3095C12.0932 13.422 12.1389 13.5275 12.2162 13.6083L16.484 17.8761C16.6492 18.0413 16.9164 18.0413 17.0816 17.8761L17.8761 17.0816C18.0413 16.9164 18.0413 16.6492 17.8761 16.484ZM7.31214 12.9369C4.20448 12.9369 1.68742 10.4198 1.68742 7.31214C1.68742 4.20448 4.20448 1.68742 7.31214 1.68742C10.4198 1.68742 12.9369 4.20448 12.9369 7.31214C12.9369 10.4198 10.4198 12.9369 7.31214 12.9369Z",
    fill: "#777777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-left.f412844c.svg";
export { ForwardRef as ReactComponent };